import { render, staticRenderFns } from "./AffiliateDashboard2.vue?vue&type=template&id=2e941b66&scoped=true&"
import script from "./AffiliateDashboard2.vue?vue&type=script&lang=js&"
export * from "./AffiliateDashboard2.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateDashboard2.vue?vue&type=style&index=0&id=2e941b66&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e941b66",
  null
  
)

export default component.exports